import * as request from "../axios";

export async function getDashboardSummary(token) {
  try {
    const response = await request.axiosGet(
      "https://rezin.pythonanywhere.com/dashboard/summary",
      token,
    );
    return response
  } catch (error) {
    console.log(error);
  }
}
